import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import store from "./app/store";
import MapTest from "./components/maps/MapTest";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import "./index.css";
import Layout from "./pages/Layout";
import NoPage from "./pages/NoPage";
import AuditLogsDetails from "./pages/audit/AuditLogsDetails";
import AuditPanel from "./pages/audit/AuditPanel";
import BandobastDetails from "./pages/bandobast/BandobastDetails";
import ListBandobast from "./pages/bandobast/ListBandobast";
import SummaryReport from "./pages/bandobast/SummaryReport";
import PersonnelReport from "./pages/bandobast/PersonnelReport";
import OverviewReport from "./pages/bandobast/OverviewReport";
import BandobastAllocationSummary from "./pages/bandobast/allocation/AllocationSummary";
import PersonnelAllocation from "./pages/bandobast/allocation/PersonnelAllocation";
import PersonnelAllocationSummary from "./pages/bandobast/allocation/PersonnelAllocationSummary";
import ResourceAllocation from "./pages/bandobast/allocation/ResourceAllocation";
import BandobastTimeslotResAllocationSum from "./pages/bandobast/allocation/ResourceAllocationSummary";
import ListExternalForces from "./pages/bandobast/external_forces/ListExternalForces";
import ListCheckinStatus from "./pages/checkin/ListCheckinStatus";
import ListDesignations from "./pages/designations/ListDesignations";
import ListLiveLocations from "./pages/live_locations/ListLiveLocations";
import ListLocations from "./pages/locations/ListLocations";
import ListOrganizations from "./pages/organizations/ListOrganizations";
import ListPersonnel from "./pages/personnel/ListPersonnel";
import ListPersonnelAllocationsOfLocation from "./pages/personnel_allocations/ListPersonnelAllocationsOfLocation";
import ListPersonnelAssessments from "./pages/personnel_assessment/ListPersonnelAssessments";
import ListPersonnelTemplates from "./pages/personnel_templates/ListPersonnelTemplates";
import ListResourceAssessments from "./pages/resource_assessments/ListResourceAssessments";
import ResourceTemplateList from "./pages/resource_templates/ListResourceTemplates";
import ListResourceTypes from "./pages/resource_types/ListResourceTypes";
import ListResources from "./pages/resources/ListResources";
import AllRolePanel from "./pages/roles/AllRolePanel";
import PermissionSelectionPanel from "./pages/roles/PermissionSelectionPanel";
import RolePermissionList from "./pages/roles/RolePermissionList";
import ListSchedules from "./pages/schedules/ListSchedules";
import ListTimeslots from "./pages/timeslots/ListTimeslots";
import ChangePwd from "./pages/users/ChangePwd";
import ListUsers from "./pages/users/ListUsers";
import LoginForm from "./pages/users/LoginForm";
import NewUserPage1 from "./pages/users/NewUserPage1";
import NewUserPage2 from "./pages/users/NewUserPage2";
import RoleSelectionPanel from "./pages/users/RoleSelectionPanel";
import UserRoleList from "./pages/users/UserRoleList";
import BandobastHomePage from "./pages/bandobast/BandobastHomePage";
import ResourceSummaryReport from "./pages/bandobast/ResourceSummaryReport";
import SummaryReport2 from "./pages/bandobast/SummaryReport2";
import AssesmentReport from "./pages/bandobast/AssesmentReport";
import AllocationsReport from "./pages/bandobast/AllocationsReport";
import AllocationsPendingReport from "./pages/bandobast/AllocationsPendingReport";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* users */}
        <Route path="/login" element={<LoginForm />}></Route>

        {/* putting these outside so that left nav pane is not shown */}

        <Route
          path="/bandobastDetails/:bandobastId"
          element={<BandobastDetails />}
        />
        <Route
          path="bandobast/reports/summary/:bandobastId"
          element={<SummaryReport />}
        />
        <Route
          path="bandobast/reports/summary2/:bandobastId"
          element={<SummaryReport2 />}
        />
        <Route
          path="bandobast/reports/assessmentReport/:bandobastId"
          element={<AssesmentReport />}
        />

        <Route
          path="bandobast/reports/allocationsReport/:bandobastId"
          element={<AllocationsReport />}
        />

        <Route
          path="bandobast/reports/allocationsPendingReport/:bandobastId"
          element={<AllocationsPendingReport />}
        />

        <Route
          path="bandobast/reports/personnel/:bandobastId"
          element={<PersonnelReport />}
        />
        <Route
          path="bandobast/reports/resourceSummary/:bandobastId"
          element={<ResourceSummaryReport />}
        />
        <Route
          path="bandobast/reports/overview/:bandobastId"
          element={<OverviewReport />}
        />

        {/* home page */}
        <Route path="/" element={<Layout />}>
          {/* top level pages */}
          <Route path="audit" element={<AuditPanel />} />
          <Route path="users" element={<ListUsers />} />
          <Route path="bandobast" element={<ListBandobast />} />
          <Route
            path="/bandobast/:bandobastId"
            element={<BandobastHomePage />}
          />
          <Route
            path="bandobast/externalForces/:bandobastId"
            element={<ListExternalForces />}
          />
          {/* <Route
            path="bandobast/newBandobastPage1"
            element={<NewBandobastPage1 />}
          />
          <Route
            path="bandobast/newBandobastPage2/:bandobastId"
            element={<NewBandobastPage2 />}
          /> */}
          <Route
            path="timeslotSummary/:bandobastId/:timeslotId"
            element={<PersonnelAllocationSummary />}
          />
          <Route
            path="timeslotResAllocationSummary/:bandobastId/:timeslotId"
            element={<BandobastTimeslotResAllocationSum />}
          />
          <Route
            path="checkinStatus/:bandobastId/:timeslotId"
            element={<ListCheckinStatus />}
          />
          <Route
            path="liveStatus/:bandobastId/:timeslotId"
            element={<ListLiveLocations />}
          />
          <Route
            path="summary/:bandobastId"
            element={<BandobastAllocationSummary />}
          />
          <Route
            path="personnelAllocation/:bandobastId/:timeslotId/:locationId/:designationId"
            element={<PersonnelAllocation />}
          />
          <Route
            path="resourceAllocation/:bandobastId/:timeslotId/:locationId/:resourceTypeId"
            element={<ResourceAllocation />}
          />
          <Route path="designations" element={<ListDesignations />} />
          <Route path="orgs" element={<ListOrganizations />} />
          <Route path="resources" element={<ListResources />} />
          <Route path="resourceTypes" element={<ListResourceTypes />} />
          <Route path="mapTest" element={<MapTest />} />
          <Route path="templates" element={<ListPersonnelTemplates />} />
          <Route path="resourceTemplates" element={<ResourceTemplateList />} />
          <Route path="schedules" element={<ListSchedules />} />
          <Route path="personnel" element={<ListPersonnel />} />
          <Route
            path="locations/:bandobastId/:timeslotId"
            element={<ListLocations />}
          />
          <Route path="timeslots/:bandobastId" element={<ListTimeslots />} />
          <Route
            path="personnelAssessments/:bandobastId/:timeslotId/:locationId"
            element={<ListPersonnelAssessments />}
          />
          <Route
            path="resourceAssessments/:bandobastId/:timeslotId/:locationId"
            element={<ListResourceAssessments />}
          />
          <Route
            path="personnelAllocations/:bandobastId/:timeslotId/:locationId"
            element={<ListPersonnelAllocationsOfLocation />}
          />
          {/* users */}
          <Route path="newUser/" element={<NewUserPage1 />} />
          <Route path="newUser2/:userId" element={<NewUserPage2 />} />
          <Route path="changePwd" element={<ChangePwd />} />

          {/* roles */}
          <Route path="roles/" element={<AllRolePanel />} />
          <Route path="roles/:userId" element={<UserRoleList />} />
          <Route path="selectRoles/:userId" element={<RoleSelectionPanel />} />
          <Route
            path="selectPermissions/:roleId"
            element={<PermissionSelectionPanel />}
          />

          {/* permissions */}
          <Route path="permissions/:roleId" element={<RolePermissionList />} />

          <Route path="audit/:auditId" element={<AuditLogsDetails />} />

          {/* non-existent page */}
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);
